(function() {
  'use strict';
  angular.module('common',[
    'ngResource',
    'dnErrorDisplay',
    'dnConfirmationMessage',
    'ui.grid',
    'ui.grid.resizeColumns',
    'ui.grid.selection',
    'ui.grid.pinning',
    'ui.grid.exporter',
    'ui.grid.moveColumns',
    'ui.grid.autoResize',
    'dso'
	]);
})();
